import { create } from 'zustand';
import { showToast } from '../Utils/showToastWrapper';
import useStore from './store';
import { openNewGroupFromFolder } from '../../platformFiles/browserAPI';
import usePersistStore from './persistStore';
import layoutStore from './layoutStore';
import { changeWorkspaceFront } from '../../platformFiles/platformMessages';
import {
    bookmarkFilter,
    getAllWorkspaces,
    getRecent,
    handleEnterAction,
    queryTabs
} from '../../platformFiles/stores/searchStoreActions';

export interface SearchDataObj {
    current: Array<any> | null;
    all: Array<any> | null;
    active: Array<any> | null;
    bookmarks: Array<any> | null;
    //history: Array<any> | null;
    //visited: Array<any> | null;
    //library: Array<any> | null;
}

type SearchStore = {
    getSearchInitData: () => void;
    selectedIndex: number;
    loadingCurrentSite: boolean;
    itemsToShow: any;
    setItemsToShow: (newData: any) => void;
    setSelectedIndex: (index: number) => void;
    moveSelection: (direction: number) => void;
    currentSearchData: SearchDataObj;
    filterText: string;
    setFilterText: (value: string) => void;
    //loadingSearchData: boolean;
    errorFetchingSearchData: boolean;
    currentFilter: string;
    setCurrentFilter: (value: string) => void;
    handleEnter: () => void;
    keyIsPressed: string;
    handleKeyPress: (key: string) => void;
    allWSdata: Array<any> | null;
    goToDetails: Object | null;
    setGoToDetails: (data: Object) => void;
};

const useSearch = create<SearchStore>(
    (set, get): SearchStore => ({
        getSearchInitData: () => {
            getSearchInitDataAction(set, get);
        },
        selectedIndex: 0,
        loadingCurrentSite: false,
        itemsToShow: null,
        setItemsToShow: (data: any) => set({ itemsToShow: data }),
        setSelectedIndex: (index) => set({ selectedIndex: index }),
        moveSelection: (dir: number) => {
            let newIndex = get().selectedIndex + dir;
            let listLength = get().itemsToShow.length;
            if (newIndex < 0) {
                newIndex = 0;
            } else if (newIndex > listLength - 1) {
                newIndex = listLength - 1;
            }
            set({
                selectedIndex: newIndex
            });
        },
        currentSearchData: {
            current: null,
            all: null,
            active: null,
            bookmarks: null
            //history: null,
            //visited: null,
            //library: null
        },
        filterText: '',
        setFilterText: (value) => set({ filterText: value }),
        //loadingSearchData: true,
        errorFetchingSearchData: false,
        currentFilter: 'current',
        setCurrentFilter: (newFilter: string) =>
            setCurrentFilter(set, get, newFilter),
        handleEnter: () => handleEnterAction(set, get),
        keyIsPressed: null,
        handleKeyPress: (key) => set({ keyIsPressed: key }),
        allWSdata: null,
        goToDetails: { toWsId: null, inCategoryIndex: null },
        setGoToDetails: (data) => set({ goToDetails: data })
    })
);

const setCurrentFilter = (set, get, newFilter) => {
    if (newFilter === get().currentFilter) {
        return;
    } else {
        //set({ loadingSearchData: true });
        set({ currentFilter: newFilter });
        set({ selectedIndex: 0 });
        // Check if data for the new filter is already set
        if (get().currentSearchData[newFilter]) {
            return;
        }
        if (newFilter === 'current') {
            getCurrentTabs(set, get);
        } else if (newFilter === 'all') {
            getAllWorkspaces(set, get);
        } else if (newFilter === 'recent') {
            getRecent(set, get);
        } else if (newFilter === 'active') {
            queryTabs(set, get);
        } else if (newFilter === 'bookmarks') {
            bookmarkFilter(set, get);
        } else if (newFilter === 'history') {
            searchHistoryAction('');
        } else if (newFilter === 'library') {
            //getCloudSearchData(set, get);
            //Agolia
        }
    }
};

/* const getAllWorkspaces = (set, get) => {
    //set current ws tabs 
    //wait for input
    
    chrome.
}; */

const getSearchInitDataAction = (set, get) => {
    getCurrentTabs(set, get);
    set({ selectedIndex: 0 });
};

const getCurrentTabs = (set, get) => {
    let group = useStore.getState().tabGroups;
    //each group here has a array of tabs on group.tabs, add them all to one array
    let allTabs = group.map((group) => group.tabs);
    let flat = allTabs.flat();
    set({
        currentSearchData: {
            ...get().currentSearchData,
            current: flat
        }
    });
    /* set({
        currentSearchData: {
            ...get().currentSearchData,
            active: activeTabs
        }
    }); */
};

const searchHistoryAction = async (query) => {
    /* chrome.history.search({ text: '' }, (res) => {
        
        return res;
    }); */
    /* chrome.history.getVisits({ url: 'https://deno.land/' }, (res) => {
        return res;
    }); */
};

export default useSearch;
